'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AuditLogRoutes;

var _auditLogsTpl = require('./audit-logs.tpl.html');

var _auditLogsTpl2 = _interopRequireDefault(_auditLogsTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
function AuditLogRoutes($stateProvider) {
    $stateProvider.state('home.auditLogs', {
        url: '/auditLogs',
        module: 'private',
        auth: ['TENANT_ADMIN'],
        views: {
            "content@home": {
                templateUrl: _auditLogsTpl2.default,
                controller: 'AuditLogsController',
                controllerAs: 'vm'
            }
        },
        data: {
            searchEnabled: false,
            pageTitle: 'audit-log.audit-logs'
        },
        ncyBreadcrumb: {
            label: '{"icon": "track_changes", "label": "audit-log.audit-logs"}'
        }
    });
} /*
   * Copyright © 2016-2018 The Thingsboard Authors
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
/* eslint-disable import/no-unresolved, import/default */


// WEBPACK FOOTER //
// ./src/app/audit/audit-log.routes.js